/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InterpolatedSeverityValueDto
 */
export interface InterpolatedSeverityValueDto {
    /**
     * 
     * @type {string}
     * @memberof InterpolatedSeverityValueDto
     */
    lowSeverity: string;
    /**
     * 
     * @type {string}
     * @memberof InterpolatedSeverityValueDto
     */
    averageSeverity: string;
    /**
     * 
     * @type {string}
     * @memberof InterpolatedSeverityValueDto
     */
    highSeverity: string;
    /**
     * 
     * @type {string}
     * @memberof InterpolatedSeverityValueDto
     */
    puEq: string;
}

/**
 * Check if a given object implements the InterpolatedSeverityValueDto interface.
 */
export function instanceOfInterpolatedSeverityValueDto(value: object): value is InterpolatedSeverityValueDto {
    if (!('lowSeverity' in value) || value['lowSeverity'] === undefined) return false;
    if (!('averageSeverity' in value) || value['averageSeverity'] === undefined) return false;
    if (!('highSeverity' in value) || value['highSeverity'] === undefined) return false;
    if (!('puEq' in value) || value['puEq'] === undefined) return false;
    return true;
}

export function InterpolatedSeverityValueDtoFromJSON(json: any): InterpolatedSeverityValueDto {
    return InterpolatedSeverityValueDtoFromJSONTyped(json, false);
}

export function InterpolatedSeverityValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InterpolatedSeverityValueDto {
    if (json == null) {
        return json;
    }
    return {
        
        'lowSeverity': json['lowSeverity'],
        'averageSeverity': json['averageSeverity'],
        'highSeverity': json['highSeverity'],
        'puEq': json['puEq'],
    };
}

export function InterpolatedSeverityValueDtoToJSON(json: any): InterpolatedSeverityValueDto {
    return InterpolatedSeverityValueDtoToJSONTyped(json, false);
}

export function InterpolatedSeverityValueDtoToJSONTyped(value?: InterpolatedSeverityValueDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lowSeverity': value['lowSeverity'],
        'averageSeverity': value['averageSeverity'],
        'highSeverity': value['highSeverity'],
        'puEq': value['puEq'],
    };
}

